<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
// import { hexToRgba } from '@/hooks/use-echart/utils';// FIXME:后台展示修改。一个小工具不需要全引用
import { vMove, vInput, useCover } from './index';
type Pos = {
  left: number;
  top: number;
  center?: boolean;
  initHeight?: number;
  left2right?: boolean;
};
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1285 1690">
  <g transform="translate(0.5 16.5)">
    <g transform="translate(443.5 148.5) rotate(90)" fill="var(--theme-color-1)">
      <path d="M 483.1571044921875 442.5 L 0.842906653881073 442.5 L 242 1.043006777763367 L 483.1571044921875 442.5 Z" stroke="none"/>
      <path d="M 242 2.08587646484375 L 1.68572998046875 442 L 482.3142700195312 442 L 242 2.08587646484375 M 242 0 L 484 443 L 0 443 L 242 0 Z" stroke="none" fill="#707070"/>
    </g>
    <path d="M217.5,0,435,398H0Z" transform="translate(1117.5 -12.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M54.5,0,109,100H0Z" transform="translate(665.5 432.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M161,0,322,296H0Z" transform="translate(296.5 452.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M22,0,44,41H0Z" transform="translate(652.5 239.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M11,0,22,20H0Z" transform="translate(285.5 244.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M10,0,20,19H0Z" transform="translate(1059.5 399.5) rotate(90)" fill="#e3e3e3"/>
    <path d="M54.5,0,109,100H0Z" transform="translate(302.5 16.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M27.5,0,55,50H0Z" transform="translate(75.5 1482.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M24,0,48,43H0Z" transform="translate(222.5 1611.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M54.5,0,109,100H0Z" transform="translate(702.5 -12.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M54.5,0,109,102H0Z" transform="translate(-0.5 179.5) rotate(-90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M13.5,0,27,25H0Z" transform="translate(148.5 1523.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M30.5,0,61,56H0Z" transform="translate(106.5 1570.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M13.5,0,27,25H0Z" transform="translate(32.5 1646.5) rotate(90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M108,0,216,198H0Z" transform="translate(397.5 431.5) rotate(-90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path d="M108,0,216,198H0Z" transform="translate(1086.5 431.5) rotate(-90)" fill="var(--theme-color-1-for-cover-6)"/>
    <path id="路径_65" data-name="路径 65" d="M145.94,267.054,291.881,0H0Z" transform="translate(941.117 323.336) rotate(90)" fill="var(--theme-color-1)"/>
    <g transform="translate(638.5 0.5) rotate(90)" fill="var(--theme-color-1)">
      <path d="M 309.1575012207031 283.5000610351562 L 0.842505931854248 283.5000610351562 L 155 1.043703675270081 L 309.1575012207031 283.5000610351562 Z" stroke="none"/>
      <path d="M 155 2.08734130859375 L 1.68499755859375 283 L 308.3150024414062 283 L 155 2.08734130859375 M 155 -3.0517578125e-05 L 310 284 L 0 284 L 155 -3.0517578125e-05 Z" stroke="none" fill="#707070"/>
    </g>
    <g transform="translate(252.5 669.5) rotate(-90)" fill="var(--theme-color-1)">
      <path d="M 259.1588439941406 238.5000457763672 L 0.841145396232605 238.5000457763672 L 130 1.046428918838501 L 259.1588439941406 238.5000457763672 Z" stroke="none"/>
      <path d="M 130 2.092849731445312 L 1.68231201171875 238.0000152587891 L 258.3176879882812 238.0000152587891 L 130 2.092849731445312 M 130 -1.52587890625e-05 L 260 239.0000152587891 L 0 239.0000152587891 L 130 -1.52587890625e-05 Z" stroke="none" fill="#707070"/>
    </g>
    <path d="M93.5,0,187,172H0Z" transform="translate(956.5 606.5) rotate(-90)" fill="#e3e3e3"/>
    <path d="M70.5,0,141,129H0Z" transform="translate(1061.5 141.5) rotate(-90)" fill="var(--theme-color-1)"/>
    <path d="M29.5,0,59,53H0Z" transform="translate(956.5 42.5) rotate(-90)" fill="#e3e3e3"/>
    <g transform="translate(949.5 732.5) rotate(-90)" fill="var(--theme-color-1)">
      <path d="M 262.1575927734375 240.5000457763672 L 0.8424030542373657 240.5000457763672 L 131.5 1.043887257575989 L 262.1575927734375 240.5000457763672 Z" stroke="none"/>
      <path d="M 131.5 2.087753295898438 L 1.684814453125 240.0000152587891 L 261.315185546875 240.0000152587891 L 131.5 2.087753295898438 M 131.5 -1.52587890625e-05 L 263 241.0000152587891 L 0 241.0000152587891 L 131.5 -1.52587890625e-05 Z" stroke="none" fill="#707070"/>
    </g>
  </g>
</svg>
`;

const { info, onPosChange, onValueChange } = useCover(emits);

function hexToRgba(hex, opacity) {
  return (
    'rgba(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ',' +
    opacity +
    ')'
  );
}

document.documentElement.style.setProperty(
  '--theme-color-1-for-cover-6',
  hexToRgba(
    document.documentElement.style.getPropertyValue('--theme-color-1'),
    0.8
  )
);
</script>
<style lang="scss" scoped>
.cover {
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.svg {
  width: calc(100% + 100px);
  height: calc(100% + 0px);
  position: absolute;
  left: 0px;
  top: -30px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  text-align: right;
}
.project-name,
.time {
  font-size: 63px;
  font-weight: 600;
  color: #404040;
}

.project-name {
  max-width: 750px;
  min-width: 500px;
}
.time {
  font-size: 36px;
  min-width: 250px;
  max-width: 690px;
  color: #484848;
}
.enterprise-name {
  font-size: 36px;
  font-weight: 600;
  max-width: 600px;
  min-width: 450px;
  color: #484848;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
